import generateQuery from '@/libs/generate-query'
import HttpRequest from './HttpRequest'

class TicketTypeProvider extends HttpRequest {
  findAll () {
    return this.get('/case-type')
  }

  findAllType () {
    return this.get('/case-type/all/type')
  }

  createGroup (payload) {
    return this.post('/case-type', payload)
  }

  updateGroup (id, payload) {
    return this.patch(`/case-type/${id}`, payload)
  }

  deleteGroup (id) {
    return this.delete(`/case-type/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/case-type?page=${page}&limit=${limit}${generateQuery(query)}`)
  }
}

export default TicketTypeProvider
